<template>
    <div>
        <vx-card>
            <div class="flex h-12 mt-1 fit-height">
                <div class="w-full ml-2 fit-height">
                    <form v-on:submit.prevent="salvar" id="formulario">
                        <vs-divider position="center"
                            >Informações básicas</vs-divider
                        >

                        <div class="vx-row mb-2">
                            <div class="vx-col w-1/4">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Empreendimento ativo?</label
                                    >
                                    <vs-switch
                                        v-model="estaAtivo"
                                        @change="mudarAtivo"
                                    >
                                        <span slot="on">Sim</span>
                                        <span slot="off">Não</span>
                                    </vs-switch>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Título</label
                                    >
                                    <div class="vs-con-input">
                                        <input
                                            v-model="empreendimento.titulo"
                                            type="text"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Sobre o imóvel</label
                                    >
                                    <div class="vs-con-input">
                                        <textarea
                                            v-model="empreendimento.descricao"
                                            type="text"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            v-on:keyup="textAreaAdjust"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Texto legal</label
                                    >
                                    <div class="vs-con-input">
                                        <textarea
                                            v-model="empreendimento.texto_legal"
                                            type="text"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            v-on:keyup="textAreaAdjust"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-1/3">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Slug</label
                                    >
                                    <div class="vs-con-input">
                                        <input
                                            v-model="empreendimento.slug"
                                            type="text"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            required
                                            v-on:keyup="slugify"
                                            v-on:blur="checaSlug"
                                        />
                                        <span
                                            class="text-danger text-sm"
                                            v-if="!uniqueSlug"
                                            >Já existe um empreendimento com
                                            este slug</span
                                        >
                                    </div>
                                </div>
                            </div>

                            <div
                                class="vx-col vs-component vs-con-input-label vs-input w-1/3 vs-input-primary"
                            >
                                <label for="" class="vs-input--label"
                                    >Lançamento</label
                                >
                                <datepicker
                                    :minimumView="'month'"
                                    :maximumView="'year'"
                                    :language="ptBR"
                                    :format="formatoData"
                                    @input="setDate"
                                    v-model="currentDate"
                                ></datepicker>
                            </div>
                            <div
                                class="vx-col vs-component vs-con-input-label vs-input w-1/3 vs-input-primary"
                            >
                                <label for="" class="vs-input--label"
                                    >Previsão conclusão obra</label
                                >
                                <datepicker
                                    :minimumView="'month'"
                                    :maximumView="'year'"
                                    :language="ptBR"
                                    :format="formatoData"
                                    @input="setDateObra"
                                    v-model="currentDateObra"
                                ></datepicker>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Categoria</label
                                    >
                                    <div class="vs-con-input">
                                        <v-select
                                            class="w-full"
                                            icon-no-border
                                            label-placeholder="Categoria"
                                            :options="optionsCategoria"
                                            @input="selectedCategoria"
                                            v-model="empreendimento.categoria"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <vs-divider position="center">Em construção</vs-divider>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-1/4">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Esse produto está em construção?</label
                                    >
                                    <vs-switch
                                        v-model="estaConstrucao"
                                        @change="mudarConstrucao"
                                    >
                                        <span slot="on">Sim</span>
                                        <span slot="off">Não</span>
                                    </vs-switch>
                                </div>
                            </div>
                        </div>

                        <div class="" v-if="estaConstrucao">
                            <div class="vx-row mb-2">
                                <div class="vx-col w-1/4">
                                    <label for="" class="vs-input--label"
                                        >Geral</label
                                    >
                                    <vs-input-number
                                        v-model="
                                            empreendimento.status_construcao
                                                .geral
                                        "
                                        class="vs-inputx vs-input--input normal"
                                        style="margin-left: 0"
                                        required
                                        min="0"
                                        max="100"
                                    />
                                </div>
                                <div class="vx-col w-1/4">
                                    <label for="" class="vs-input--label"
                                        >Fundação</label
                                    >
                                    <vs-input-number
                                        v-model="
                                            empreendimento.status_construcao
                                                .fundacao
                                        "
                                        class="vs-inputx vs-input--input normal"
                                        style="margin-left: 0"
                                        required
                                        min="0"
                                        max="100"
                                    />
                                </div>
                                <div class="vx-col w-1/4">
                                    <label for="" class="vs-input--label"
                                        >Estrutura</label
                                    >
                                    <vs-input-number
                                        v-model="
                                            empreendimento.status_construcao
                                                .estrutura
                                        "
                                        class="vs-inputx vs-input--input normal"
                                        style="margin-left: 0"
                                        required
                                        min="0"
                                        max="100"
                                    />
                                </div>
                                <div class="vx-col w-1/4">
                                    <label for="" class="vs-input--label"
                                        >Alvenaria</label
                                    >
                                    <vs-input-number
                                        v-model="
                                            empreendimento.status_construcao
                                                .alvenaria
                                        "
                                        class="vs-inputx vs-input--input normal"
                                        style="margin-left: 0"
                                        required
                                        min="0"
                                        max="100"
                                    />
                                </div>
                            </div>

                            <div class="vx-row mb-2">
                                <div class="vx-col w-1/4">
                                    <label for="" class="vs-input--label"
                                        >Hidráulica</label
                                    >
                                    <vs-input-number
                                        v-model="
                                            empreendimento.status_construcao
                                                .hidraulica
                                        "
                                        class="vs-inputx vs-input--input normal"
                                        style="margin-left: 0"
                                        required
                                        min="0"
                                        max="100"
                                    />
                                </div>
                                <div class="vx-col w-1/4">
                                    <label for="" class="vs-input--label"
                                        >Elétrica</label
                                    >
                                    <vs-input-number
                                        v-model="
                                            empreendimento.status_construcao
                                                .eletrica
                                        "
                                        class="vs-inputx vs-input--input normal"
                                        style="margin-left: 0"
                                        required
                                        min="0"
                                        max="100"
                                    />
                                </div>
                                <div class="vx-col w-1/4">
                                    <label for="" class="vs-input--label"
                                        >Acabamento</label
                                    >
                                    <vs-input-number
                                        v-model="
                                            empreendimento.status_construcao
                                                .acabamento
                                        "
                                        class="vs-inputx vs-input--input normal"
                                        style="margin-left: 0"
                                        required
                                        min="0"
                                        max="100"
                                    />
                                </div>
                                <div class="vx-col w-1/4">
                                    <label for="" class="vs-input--label"
                                        >Pintura</label
                                    >
                                    <vs-input-number
                                        v-model="
                                            empreendimento.status_construcao
                                                .pintura
                                        "
                                        class="vs-inputx vs-input--input normal"
                                        style="margin-left: 0"
                                        required
                                        min="0"
                                        max="100"
                                    />
                                </div>
                            </div>
                        </div>

                        <vs-divider position="center"
                            >Quantidade em estoque</vs-divider
                        >

                        <div class="vx-row mb-2">
                            <div class="vx-col w-1/4">
                                <label for="" class="vs-input--label"
                                    >Estoque</label
                                >
                                <vs-input-number
                                    v-model="empreendimento.quantidade_estoque"
                                    class="vs-inputx vs-input--input normal"
                                    style="margin-left: 0"
                                    required
                                    min="0"
                                />
                            </div>
                        </div>

                        <div class="float-right" v-if="!adicionandoMetragem">
                            <vs-button
                                color="success"
                                icon-pack="feather"
                                icon="icon-plus-square"
                                type="flat"
                                size="large"
                                v-on:click="adicionar('metragem')"
                                >Adicionar metragem</vs-button
                            >
                        </div>

                        <vs-divider position="center"
                            >Metragem e Valor</vs-divider
                        >
                        <vs-list>
                            <draggable :list="empreendimento.metragem">
                                <transition-group>
                                    <vs-list-item
                                        class="list-item"
                                        v-for="(item,
                                        index) in empreendimento.metragem"
                                        :key="'metragem' + index"
                                        :title="item.metros + 'm'"
                                        :subtitle="'R$ ' + item.preco"
                                    >
                                        <vs-button
                                            radius
                                            color="warning"
                                            type="flat"
                                            icon-pack="feather"
                                            icon="icon-edit"
                                            v-on:click="
                                                editar('metragem', index)
                                            "
                                            :key="'metragem' + index + 'editar'"
                                        ></vs-button>
                                        <vs-button
                                            radius
                                            color="danger"
                                            type="flat"
                                            icon-pack="feather"
                                            icon="icon-x-square"
                                            v-on:click="
                                                remover('metragem', index)
                                            "
                                            :key="
                                                'metragem' + index + 'remover'
                                            "
                                        ></vs-button>
                                    </vs-list-item>
                                </transition-group>
                            </draggable>
                            <div
                                class="flex h-12 mt-1 fit-height"
                                v-if="adicionandoMetragem"
                            >
                                <div class="w-1/3">
                                    <vs-input
                                        class="w-full"
                                        icon-pack="feather"
                                        icon="icon-star"
                                        icon-no-border
                                        label-placeholder="Metros"
                                        v-model="entradaMetros.metros"
                                        id="adicionarMetragemInput"
                                    />
                                </div>
                                <div class="w-1/3 ml-2">
                                    <vs-input
                                        type="text"
                                        class="w-full"
                                        icon-pack="feather"
                                        icon="icon-link"
                                        icon-no-border
                                        label-placeholder="Preço"
                                        v-model="entradaMetros.preco"
                                    />
                                </div>
                                <div class="w-1/3 ml-2">
                                    <vs-button
                                        color="danger"
                                        icon-pack="feather"
                                        icon="icon-x-square"
                                        style="float: left;"
                                        class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                        v-on:click="pararAdicao()"
                                    ></vs-button>
                                    <vs-button
                                        color="success"
                                        icon-pack="feather"
                                        icon="icon-check-square"
                                        style="float: left;"
                                        class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                        v-on:click="confirmarAdicao('metragem')"
                                    ></vs-button>
                                </div>
                            </div>
                        </vs-list>

                        <vs-divider position="center"
                            >Stand de Vendas</vs-divider
                        >

                        <div class="vx-row mb-2">
                            <div class="vx-col w-1/2">
                                <label for="" class="vs-input--label"
                                    >Latitude</label
                                >
                                <input
                                    type="text"
                                    v-model="
                                        empreendimento.localizacao.latitude
                                    "
                                    class="vs-inputx vs-input--input normal"
                                    style="margin-left: 0"
                                    required
                                />
                            </div>
                            <div
                                class="vx-col vs-component vs-con-input-label vs-input w-1/2 vs-input-primary"
                            >
                                <label for="" class="vs-input--label"
                                    >Longitude</label
                                >
                                <input
                                    type="text"
                                    v-model="
                                        empreendimento.localizacao.longitude
                                    "
                                    class="vs-inputx vs-input--input normal"
                                    required
                                />
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Zona</label
                                    >
                                    <div class="vs-con-input">
                                        <input
                                            v-model="
                                                empreendimento.localizacao.zona
                                            "
                                            type="text"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Bairro</label
                                    >
                                    <div class="vs-con-input">
                                        <input
                                            v-model="
                                                empreendimento.localizacao
                                                    .bairro
                                            "
                                            type="text"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Endereço</label
                                    >
                                    <div class="vs-con-input">
                                        <input
                                            v-model="
                                                empreendimento.localizacao
                                                    .endereco
                                            "
                                            type="text"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <vs-divider position="center"
                            >Endereço do Empreendimento</vs-divider
                        >

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-divider position="left"
                                    >Foto da Região</vs-divider
                                >
                                <div class="vx-row">
                                    <div class="w-1/3">
                                        <img
                                            :src="empreendimento.imagem_regiao"
                                            v-if="
                                                empreendimento.imagem_regiao !=
                                                    ''
                                            "
                                            style="max-width: 100%"
                                        />
                                    </div>
                                    <div class="w-1/2 ml-6">
                                        <vs-upload
                                            automatic
                                            text="Enviar imagem da região"
                                            :action="
                                                this.$API_URL + '/upload/regiao'
                                            "
                                            @on-success="successUploadRegiao"
                                            accept="image/*"
                                            fileName="fotos"
                                            :single-upload="true"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label"
                                    >Endereço</label
                                >
                                <input
                                    type="text"
                                    v-model="
                                        empreendimento.localizacao
                                            .endereco_empreendimento
                                    "
                                    class="vs-inputx vs-input--input normal"
                                    style="margin-left: 0"
                                    required
                                />
                            </div>
                        </div>

                        <div class="float-right" v-if="!adicionandoFacilidade">
                            <vs-button
                                color="success"
                                icon-pack="feather"
                                icon="icon-plus-square"
                                type="flat"
                                size="large"
                                v-on:click="adicionar('facilidades')"
                                >Adicionar Diferencial</vs-button
                            >
                        </div>

                        <vs-divider position="left">Diferenciais</vs-divider>
                        <vs-list>
                            <draggable :list="empreendimento.facilidades">
                                <transition-group>
                                    <vs-list-item
                                        class="list-item"
                                        v-for="(item,
                                        index) in empreendimento.facilidades"
                                        :key="'facilidades' + index"
                                        :title="item.texto"
                                        :subtitle="item.icone"
                                    >
                                        <font-awesome-icon
                                            :icon="item.icone"
                                            slot="avatar"
                                            style="margin-right: 20px;"
                                        />
                                        <vs-button
                                            radius
                                            color="danger"
                                            type="flat"
                                            icon-pack="feather"
                                            icon="icon-x-square"
                                            v-on:click="
                                                remover('facilidades', index)
                                            "
                                            :key="
                                                'facilidades' +
                                                    index +
                                                    'remover'
                                            "
                                        ></vs-button>
                                    </vs-list-item>
                                </transition-group>
                            </draggable>
                            <div
                                class="flex h-12 mt-1 fit-height"
                                v-if="adicionandoFacilidade"
                            >
                                <div class="w-1/3">
                                    <label for="">Texto</label>
                                    <v-select
                                        class="w-full"
                                        icon-pack="feather"
                                        icon="icon-star"
                                        icon-no-border
                                        label-placeholder="Texto"
                                        taggable
                                        :options="optionsCaracteristicasTexto"
                                        push-tags
                                        v-model="entradaCaracteristica.texto"
                                        @input="selectedCaracteristica"
                                    />
                                </div>
                                <div class="w-1/3 ml-2">
                                    <label for="">Icone</label>
                                    <v-select
                                        class="w-full"
                                        icon-pack="feather"
                                        icon="icon-star"
                                        icon-no-border
                                        label-placeholder="Icone"
                                        taggable
                                        :options="optionsCaracteristicasIcones"
                                        push-tags
                                        v-model="entradaCaracteristica.icone"
                                    >
                                        <template v-slot:option="option">
                                            <font-awesome-icon
                                                :icon="option.label"
                                            />
                                            <span></span>
                                            {{ option.label }}
                                        </template>
                                    </v-select>
                                </div>
                                <div class="w-1/3 ml-2">
                                    <vs-button
                                        color="danger"
                                        icon-pack="feather"
                                        icon="icon-x-square"
                                        style="float: left;"
                                        class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                        v-on:click="pararAdicao()"
                                    ></vs-button>
                                    <vs-button
                                        color="success"
                                        icon-pack="feather"
                                        icon="icon-check-square"
                                        style="float: left;"
                                        class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                        v-on:click="
                                            confirmarAdicao('facilidades')
                                        "
                                    ></vs-button>
                                </div>
                            </div>
                        </vs-list>

                        <vs-divider position="center">Badges</vs-divider>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <div class="vs-con-input">
                                        <ul class="centerx">
                                            <li>
                                                <vs-checkbox
                                                    v-on:change="toggleBadge"
                                                    v-model="badgeMCMV"
                                                    >Minha Casa Minha
                                                    Vida</vs-checkbox
                                                >
                                            </li>
                                            <li>
                                                <vs-checkbox
                                                    v-on:change="toggleBadge"
                                                    v-model="badgeFGTS"
                                                    >Use o seu FGTS</vs-checkbox
                                                >
                                            </li>
                                            <li>
                                                <vs-checkbox
                                                    v-on:change="toggleBadge"
                                                    v-model="badgeAmplamente"
                                                    >Amplamente
                                                    Financiado</vs-checkbox
                                                >
                                            </li>
                                            <li>
                                                <vs-checkbox
                                                    v-on:change="toggleBadge"
                                                    v-model="badge360"
                                                    >360 meses
                                                    financiado</vs-checkbox
                                                >
                                            </li>
                                            <li>
                                                <vs-checkbox
                                                    v-on:change="toggleBadge"
                                                    v-model="escrituraGratis"
                                                    >Escritura
                                                    Grátis</vs-checkbox
                                                >
                                            </li>
                                            <li>
                                                <vs-checkbox
                                                    v-on:change="toggleBadge"
                                                    v-model="badgeBF"
                                                    >Black Friday
                                                    2020</vs-checkbox
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="float-right"
                            v-if="!adicionandoCaracteristica"
                        >
                            <vs-button
                                color="success"
                                icon-pack="feather"
                                icon="icon-plus-square"
                                type="flat"
                                size="large"
                                v-on:click="adicionar('caracteristicas')"
                                >Adicionar característica</vs-button
                            >
                        </div>

                        <vs-divider position="center"
                            >Características e Facilidades</vs-divider
                        >
                        <vs-list>
                            <draggable :list="empreendimento.caracteristicas">
                                <transition-group>
                                    <vs-list-item
                                        class="list-item"
                                        v-for="(item,
                                        index) in empreendimento.caracteristicas"
                                        :key="'caracteristica' + index"
                                        :title="item.texto"
                                        :subtitle="item.icone"
                                    >
                                        <font-awesome-icon
                                            :icon="item.icone"
                                            slot="avatar"
                                            style="margin-right: 20px;"
                                        />
                                        <vs-button
                                            radius
                                            color="danger"
                                            type="flat"
                                            icon-pack="feather"
                                            icon="icon-x-square"
                                            v-on:click="
                                                remover(
                                                    'caracteristicas',
                                                    index
                                                )
                                            "
                                            :key="
                                                'caracteristica' +
                                                    index +
                                                    'remover'
                                            "
                                        ></vs-button>
                                    </vs-list-item>
                                </transition-group>
                            </draggable>
                            <div
                                class="flex h-12 mt-1 fit-height"
                                v-if="adicionandoCaracteristica"
                            >
                                <div class="w-1/3">
                                    <label for="">Texto</label>
                                    <v-select
                                        class="w-full"
                                        icon-pack="feather"
                                        icon="icon-star"
                                        icon-no-border
                                        label-placeholder="Texto"
                                        taggable
                                        :options="optionsCaracteristicasTexto"
                                        push-tags
                                        v-model="entradaCaracteristica.texto"
                                        @input="selectedCaracteristica"
                                    />
                                </div>
                                <div class="w-1/3 ml-2">
                                    <label for="">Icone</label>
                                    <v-select
                                        class="w-full"
                                        icon-pack="feather"
                                        icon="icon-star"
                                        icon-no-border
                                        label-placeholder="Icone"
                                        taggable
                                        :options="optionsCaracteristicasIcones"
                                        push-tags
                                        v-model="entradaCaracteristica.icone"
                                    >
                                        <template v-slot:option="option">
                                            <font-awesome-icon
                                                :icon="option.label"
                                            />
                                            <span></span>
                                            {{ option.label }}
                                        </template>
                                    </v-select>
                                </div>
                                <div class="w-1/3 ml-2">
                                    <vs-button
                                        color="danger"
                                        icon-pack="feather"
                                        icon="icon-x-square"
                                        style="float: left;"
                                        class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                        v-on:click="pararAdicao()"
                                    ></vs-button>
                                    <vs-button
                                        color="success"
                                        icon-pack="feather"
                                        icon="icon-check-square"
                                        style="float: left;"
                                        class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                        v-on:click="
                                            confirmarAdicao('caracteristicas')
                                        "
                                    ></vs-button>
                                </div>
                            </div>
                        </vs-list>

                        <div class="float-right" v-if="!adicionandoFicha">
                            <vs-button
                                color="success"
                                icon-pack="feather"
                                icon="icon-plus-square"
                                type="flat"
                                size="large"
                                v-on:click="adicionar('ficha')"
                                >Adicionar Ficha</vs-button
                            >
                        </div>

                        <vs-divider position="center">Ficha Técnica</vs-divider>
                        <vs-list>
                            <draggable :list="empreendimento.ficha_tecnica">
                                <transition-group>
                                    <vs-list-item
                                        class="list-item"
                                        v-for="(item,
                                        index) in empreendimento.ficha_tecnica"
                                        :key="'ficha' + index"
                                        :title="item.titulo"
                                        :subtitle="item.valor"
                                    >
                                        <vs-button
                                            radius
                                            color="warning"
                                            type="flat"
                                            icon-pack="feather"
                                            icon="icon-edit"
                                            v-on:click="editar('ficha', index)"
                                            :key="'ficha' + index + 'editar'"
                                        ></vs-button>
                                        <vs-button
                                            radius
                                            color="danger"
                                            type="flat"
                                            icon-pack="feather"
                                            icon="icon-x-square"
                                            v-on:click="remover('ficha', index)"
                                            :key="'ficha' + index + 'remover'"
                                        ></vs-button>
                                    </vs-list-item>
                                </transition-group>
                            </draggable>
                            <div
                                class="flex h-12 mt-1 fit-height"
                                v-if="adicionandoFicha"
                            >
                                <div class="w-1/3">
                                    <label for="">Título</label>
                                    <v-select
                                        class="w-full"
                                        icon-pack="feather"
                                        icon="icon-star"
                                        icon-no-border
                                        label-placeholder="Título"
                                        taggable
                                        :options="optionsFichaTecnica"
                                        push-tags
                                        v-model="entradaFicha.titulo"
                                        id="adicionandoFichaInput"
                                    />
                                </div>
                                <div class="w-1/3 ml-2">
                                    <label for="">Valor</label>
                                    <vs-input
                                        type="text"
                                        class="w-full"
                                        placeholder="Valor"
                                        v-model="entradaFicha.valor"
                                    />
                                </div>
                                <div class="w-1/3 ml-2">
                                    <vs-button
                                        color="danger"
                                        icon-pack="feather"
                                        icon="icon-x-square"
                                        style="float: left;"
                                        class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                        v-on:click="pararAdicao()"
                                    ></vs-button>
                                    <vs-button
                                        color="success"
                                        icon-pack="feather"
                                        icon="icon-check-square"
                                        style="float: left;"
                                        class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                        v-on:click="confirmarAdicao('ficha')"
                                    ></vs-button>
                                </div>
                            </div>
                        </vs-list>

                        <div class="float-right" v-if="!adicionandoQuarto">
                            <vs-button
                                color="success"
                                icon-pack="feather"
                                icon="icon-plus-square"
                                type="flat"
                                size="large"
                                v-on:click="adicionar('quarto')"
                                >Adicionar quarto</vs-button
                            >
                        </div>

                        <vs-divider position="center">Quartos</vs-divider>
                        <vs-list>
                            <draggable :list="empreendimento.quartos">
                                <transition-group>
                                    <vs-list-item
                                        class="list-item"
                                        v-for="(item,
                                        index) in empreendimento.quartos"
                                        :key="'quartos' + index"
                                        :title="item.qtde.toString()"
                                    >
                                        <vs-button
                                            radius
                                            color="danger"
                                            type="flat"
                                            icon-pack="feather"
                                            icon="icon-x-square"
                                            v-on:click="
                                                remover('quarto', index)
                                            "
                                            :key="'quarto' + index + 'remover'"
                                        ></vs-button>
                                    </vs-list-item>
                                </transition-group>
                            </draggable>
                            <div
                                class="flex h-12 mt-1 fit-height"
                                v-if="adicionandoQuarto"
                            >
                                <div class="w-1/3">
                                    <vs-input
                                        class="w-full"
                                        icon-pack="feather"
                                        icon="icon-star"
                                        icon-no-border
                                        label-placeholder="Quantidade de Quartos"
                                        v-model.number="entradaQuarto.qtde"
                                        id="adicionarQuartoInput"
                                    />
                                </div>
                                <div class="w-1/3 ml-2">
                                    <vs-button
                                        color="danger"
                                        icon-pack="feather"
                                        icon="icon-x-square"
                                        style="float: left;"
                                        class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                        v-on:click="pararAdicao()"
                                    ></vs-button>
                                    <vs-button
                                        color="success"
                                        icon-pack="feather"
                                        icon="icon-check-square"
                                        style="float: left;"
                                        class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                        v-on:click="confirmarAdicao('quarto')"
                                    ></vs-button>
                                </div>
                            </div>
                        </vs-list>

                        <vs-divider position="center">Mídia</vs-divider>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-divider position="left">Fotos</vs-divider>

                                <vs-list>
                                    <draggable :list="empreendimento.fotos">
                                        <transition-group>
                                            <vs-list-item
                                                class="list-item"
                                                v-for="(item,
                                                index) in empreendimento.fotos"
                                                :key="'foto' + index"
                                                :title="item.texto"
                                                :subtitle="
                                                    item.banner
                                                        ? 'Imagem definida como banner do empreendimento'
                                                        : item.banner_mobile
                                                        ? 'Imagem definida como banner mobile'
                                                        : ''
                                                "
                                            >
                                                <vs-avatar
                                                    slot="avatar"
                                                    :src="item.path"
                                                />
                                                <vs-button
                                                    radius
                                                    color="warning"
                                                    type="flat"
                                                    icon-pack="feather"
                                                    icon="icon-edit"
                                                    v-on:click="
                                                        editar('foto', index)
                                                    "
                                                    :key="
                                                        'foto' +
                                                            index +
                                                            'editar'
                                                    "
                                                ></vs-button>
                                                <vs-button
                                                    radius
                                                    color="danger"
                                                    type="flat"
                                                    icon-pack="feather"
                                                    icon="icon-x-square"
                                                    v-on:click="
                                                        remover('foto', index)
                                                    "
                                                    :key="
                                                        'foto' +
                                                            index +
                                                            'remover'
                                                    "
                                                ></vs-button>
                                            </vs-list-item>
                                        </transition-group>
                                    </draggable>
                                    <div
                                        class="flex h-12 mt-1 fit-height"
                                        v-if="editandoFotos"
                                    >
                                        <div class="w-1/3">
                                            <vs-input
                                                icon-pack="feather"
                                                icon="icon-star"
                                                icon-no-border
                                                label-placeholder="Texto"
                                                v-model="fotoEntrada.texto"
                                                id="fotoEntradaTextoInput"
                                            />
                                        </div>
                                        <div class="w-1/3 ml-2">
                                            <label
                                                for=""
                                                class="vs-input--label"
                                                >Banner Desktop?</label
                                            >
                                            <vs-switch
                                                v-model="fotoEntrada.banner"
                                            />
                                        </div>
                                        <div class="w-1/3 ml-2">
                                            <label
                                                for=""
                                                class="vs-input--label"
                                                >Banner mobile?</label
                                            >
                                            <vs-switch
                                                v-model="
                                                    fotoEntrada.banner_mobile
                                                "
                                            />
                                        </div>
                                        <div class="w-1/3 ml-2">
                                            <vs-button
                                                color="danger"
                                                icon-pack="feather"
                                                icon="icon-x-square"
                                                style="float: left;"
                                                class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                                v-on:click="pararAdicao()"
                                            ></vs-button>
                                            <vs-button
                                                color="success"
                                                icon-pack="feather"
                                                icon="icon-check-square"
                                                style="float: left;"
                                                class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                                v-on:click="
                                                    confirmarAdicao('foto')
                                                "
                                            ></vs-button>
                                        </div>
                                    </div>
                                </vs-list>

                                <vs-upload
                                    automatic
                                    multiple
                                    text="Enviar fotos"
                                    :action="this.$API_URL + '/upload/foto'"
                                    @on-success="successUpload"
                                    accept="image/*"
                                    fileName="fotos"
                                    :single-upload="true"
                                />
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="float-right"
                                    v-if="!adicionandoVideo"
                                >
                                    <vs-button
                                        color="success"
                                        icon-pack="feather"
                                        icon="icon-plus-square"
                                        type="flat"
                                        size="large"
                                        v-on:click="adicionar('video')"
                                        >Adicionar vídeo</vs-button
                                    >
                                </div>

                                <vs-divider position="left">Vídeos</vs-divider>

                                <div class="vx-row" :key="fakeKeyToForceUpdate">
                                    <div
                                        v-for="(item,
                                        index) in empreendimento.videos"
                                        :key="'video' + index"
                                        class="w-1/3"
                                    >
                                        <iframe
                                            :src="item.video_preview"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen
                                            :key="'video_preview' + index"
                                        ></iframe>

                                        <vs-button
                                            radius
                                            color="danger"
                                            type="flat"
                                            icon-pack="feather"
                                            icon="icon-x-square"
                                            v-on:click="remover('video', index)"
                                            :key="'video' + index + 'remover'"
                                        ></vs-button>
                                    </div>
                                </div>

                                <div
                                    class="flex h-12 mt-1 fit-height"
                                    v-if="adicionandoVideo"
                                >
                                    <div class="w-2/3">
                                        <div class="vx-col w-2/3">
                                            <div
                                                class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                            >
                                                <label
                                                    for=""
                                                    class="vs-input--label"
                                                    >Link do YouTube</label
                                                >
                                                <div class="vs-con-input">
                                                    <input
                                                        v-model="
                                                            entradaVideo.video
                                                        "
                                                        type="text"
                                                        class="vs-inputx vs-input--input normal"
                                                        style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                                        required
                                                        @blur="changeVideo"
                                                        id="adicionandoVideoInput"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vx-col w-1/3 mt-10">
                                            <iframe
                                                :src="
                                                    entradaVideo.video_preview
                                                "
                                                frameborder="0"
                                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                allowfullscreen
                                                v-if="
                                                    entradaVideo.video_preview
                                                "
                                            ></iframe>
                                        </div>
                                    </div>
                                    <div class="w-1/3 ml-2">
                                        <vs-button
                                            color="danger"
                                            icon-pack="feather"
                                            icon="icon-x-square"
                                            style="float: left;"
                                            class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                            v-on:click="pararAdicao()"
                                        ></vs-button>
                                        <vs-button
                                            color="success"
                                            icon-pack="feather"
                                            icon="icon-check-square"
                                            style="float: left;"
                                            class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                            v-on:click="
                                                confirmarAdicao('video')
                                            "
                                        ></vs-button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-divider position="left">Plantas</vs-divider>

                                <vs-list>
                                    <draggable :list="empreendimento.plantas">
                                        <transition-group>
                                            <vs-list-item
                                                class="list-item"
                                                v-for="(item,
                                                index) in empreendimento.plantas"
                                                :key="'planta' + index"
                                                :title="item.texto"
                                            >
                                                <vs-avatar
                                                    slot="avatar"
                                                    :src="item.path"
                                                />
                                                <vs-button
                                                    radius
                                                    color="warning"
                                                    type="flat"
                                                    icon-pack="feather"
                                                    icon="icon-edit"
                                                    v-on:click="
                                                        editar('planta', index)
                                                    "
                                                    :key="
                                                        'planta' +
                                                            index +
                                                            'editar'
                                                    "
                                                ></vs-button>
                                                <vs-button
                                                    radius
                                                    color="danger"
                                                    type="flat"
                                                    icon-pack="feather"
                                                    icon="icon-x-square"
                                                    v-on:click="
                                                        remover('planta', index)
                                                    "
                                                    :key="
                                                        'planta' +
                                                            index +
                                                            'remover'
                                                    "
                                                ></vs-button>
                                            </vs-list-item>
                                        </transition-group>
                                    </draggable>
                                    <div
                                        class="flex h-12 mt-1 fit-height"
                                        v-if="editandoPlanta"
                                    >
                                        <div class="w-2/3">
                                            <vs-input
                                                icon-pack="feather"
                                                icon="icon-star"
                                                icon-no-border
                                                label-placeholder="Texto"
                                                v-model="entradaPlanta.texto"
                                                id="plantaEntradaTextoInput"
                                            />
                                        </div>
                                        <div class="w-1/3 ml-2">
                                            <vs-button
                                                color="danger"
                                                icon-pack="feather"
                                                icon="icon-x-square"
                                                style="float: left;"
                                                class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                                v-on:click="pararAdicao()"
                                            ></vs-button>
                                            <vs-button
                                                color="success"
                                                icon-pack="feather"
                                                icon="icon-check-square"
                                                style="float: left;"
                                                class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                                v-on:click="
                                                    confirmarAdicao('planta')
                                                "
                                            ></vs-button>
                                        </div>
                                    </div>
                                </vs-list>

                                <vs-upload
                                    automatic
                                    multiple
                                    text="Enviar plantas"
                                    :action="this.$API_URL + '/upload/planta'"
                                    @on-success="successUploadPlanta"
                                    accept="image/*"
                                    fileName="fotos"
                                    :single-upload="true"
                                />
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-divider position="left"
                                    >Thumbnail</vs-divider
                                >
                                <div class="vx-row">
                                    <div class="w-1/3">
                                        <img
                                            :src="empreendimento.thumbnail.path"
                                            v-if="empreendimento.thumbnail.path"
                                            style="max-width: 100%"
                                        />
                                    </div>
                                    <div class="w-1/2 ml-6">
                                        <vs-upload
                                            automatic
                                            multiple
                                            text="Enviar thumbnail"
                                            :action="
                                                this.$API_URL + '/upload/thumb'
                                            "
                                            @on-success="successUploadThumb"
                                            accept="image/*"
                                            fileName="fotos"
                                            :single-upload="true"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <vs-divider position="left">Tour</vs-divider>

                                <vs-list>
                                    <draggable :list="empreendimento.tours">
                                        <transition-group>
                                            <vs-list-item
                                                class="list-item"
                                                v-for="(item,
                                                index) in empreendimento.tours"
                                                :key="'tour' + index"
                                                :title="
                                                    item.titulo
                                                        ? item.titulo
                                                        : 'tour ' + index
                                                "
                                            >
                                                <vs-button
                                                    color="primary"
                                                    @click="openTour(item.tour)"
                                                    type="flat"
                                                    >Abrir tour</vs-button
                                                >
                                                <vs-button
                                                    color="warning"
                                                    @click="
                                                        editar('tour', index)
                                                    "
                                                    type="flat"
                                                    >Editar tour</vs-button
                                                >
                                                <vs-button
                                                    color="danger"
                                                    v-on:click="
                                                        remover('tour', index)
                                                    "
                                                    :key="
                                                        'tour' +
                                                            index +
                                                            'remover'
                                                    "
                                                    type="flat"
                                                    >Remover tour</vs-button
                                                >
                                            </vs-list-item>
                                        </transition-group>
                                    </draggable>
                                </vs-list>

                                <div
                                    class="flex h-12 mt-1 fit-height"
                                    v-if="editandoTour"
                                >
                                    <div class="w-2/3">
                                        <vs-input
                                            icon-pack="feather"
                                            icon="icon-star"
                                            icon-no-border
                                            label-placeholder="Título"
                                            v-model="entradaTour.titulo"
                                            id="tourEntradaTextoInput"
                                        />
                                    </div>
                                    <div class="w-1/3 ml-2">
                                        <vs-button
                                            color="danger"
                                            icon-pack="feather"
                                            icon="icon-x-square"
                                            style="float: left;"
                                            class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                                            v-on:click="pararAdicao()"
                                        ></vs-button>
                                        <vs-button
                                            color="success"
                                            icon-pack="feather"
                                            icon="icon-check-square"
                                            style="float: left;"
                                            class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder"
                                            v-on:click="confirmarAdicao('tour')"
                                        ></vs-button>
                                    </div>
                                </div>

                                <vs-upload
                                    automatic
                                    text="Enviar tour"
                                    :action="
                                        this.$API_URL + '/upload-to-s3/tour'
                                    "
                                    @on-success="successUploadTour"
                                    accept="zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
                                    fileName="tour"
                                    :single-upload="false"
                                />
                            </div>
                        </div>

                        <vs-divider position="center"
                            >Categoria Destaque</vs-divider
                        >

                        <div class="vx-row mb-2">
                            <div class="vx-col w-1/4">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Esse produto será destacado?</label
                                    >
                                    <vs-switch
                                        v-model="seraCategoriaDestaque"
                                        @change="mudarCategoriaDestaque"
                                    >
                                        <span slot="on">Sim</span>
                                        <span slot="off">Não</span>
                                    </vs-switch>
                                </div>
                            </div>
                            <div
                                class="vx-col w-1/5"
                                v-if="seraCategoriaDestaque"
                            >
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Defina a posição na categoria</label
                                    >

                                    <div class="vs-con-input">
                                        <vs-input-number
                                            v-model="
                                                empreendimento.categoria_destaque
                                            "
                                            class="vs-inputx vs-input--input normal"
                                            style="margin-left: 0"
                                            required
                                            min="0"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <vs-divider position="center"
                            >Banner principal (home)</vs-divider
                        >

                        <div class="vx-row mb-2">
                            <div class="vx-col w-1/4">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Esse produto aparecerá no banner da
                                        home?</label
                                    >
                                    <vs-switch
                                        v-model="seraDestaque"
                                        @change="mudarDestaque"
                                    >
                                        <span slot="on">Sim</span>
                                        <span slot="off">Não</span>
                                    </vs-switch>
                                </div>
                            </div>
                            <div class="vx-col w-1/5" v-if="seraDestaque">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Defina a posição</label
                                    >

                                    <div class="vs-con-input">
                                        <vs-input-number
                                            v-model="
                                                empreendimento.destaque_home
                                            "
                                            class="vs-inputx vs-input--input normal"
                                            style="margin-left: 0"
                                            required
                                            min="0"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <vs-divider position="center">Oportunidade</vs-divider>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-1/4">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Esse produto é uma oportunidade?</label
                                    >
                                    <vs-switch
                                        v-model="seraOportunidade"
                                        @change="mudarOportunidade"
                                    >
                                        <span slot="on">Sim</span>
                                        <span slot="off">Não</span>
                                    </vs-switch>
                                </div>
                            </div>
                        </div>

                        <vs-divider position="center">CRM</vs-divider>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-1/2">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Chat</label
                                    >
                                    <div class="vs-con-input">
                                        <input
                                            v-model="
                                                empreendimento.contato_corretor
                                            "
                                            type="url"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-1/2">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >WhatsApp</label
                                    >
                                    <div class="vs-con-input">
                                        <input
                                            v-model="
                                                empreendimento.crm_whatsapp
                                            "
                                            type="url"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <vs-divider position="center">Telefone</vs-divider>

                        <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                                <div
                                    class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                                >
                                    <label for="" class="vs-input--label"
                                        >Telefone</label
                                    >
                                    <div class="vs-con-input">
                                        <the-mask
                                            :mask="[
                                                '(##) ####-####',
                                                '(##) #####-####'
                                            ]"
                                            class="vs-inputx vs-input--input normal"
                                            style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                            required
                                            v-model="empreendimento.telefone"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />
                        <br />
                        <vs-row
                            vs-type="flex"
                            vs-justify="center"
                            style="width: 100%"
                        >
                            <div
                                style="width:inherit; position: fixed; bottom: 20px; text-align: center;"
                            >
                                <vs-button
                                    size="large"
                                    class="vs-component vs-button mr-3 mb-2 vs-button-danger vs-button-filled"
                                    v-on:click="voltar"
                                    >Voltar</vs-button
                                >
                                <vs-button
                                    size="large"
                                    class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled"
                                    v-on:click="salvar"
                                    >Salvar</vs-button
                                >
                            </div>
                        </vs-row>
                    </form>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import vSelect from "vue-select";
import draggable from "vuedraggable";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/src/locale";

export default {
    components: {
        TheMask,
        "v-select": vSelect,
        draggable,
        Datepicker
    },
    data() {
        return {
            estaAtivo: false,
            editandoTour: false,
            entradaTour: {
                titulo: "",
                tour: "",
                index: 0
            },
            seraCategoriaDestaque: false,
            badgeFGTS: false,
            badgeMCMV: false,
            badgeAmplamente: false,
            badge360: false,
            badgeBF: false,
            escrituraGratis: false,
            uniqueSlug: true,
            editandoPlanta: false,
            true: true,
            seraDestaque: false,
            currentDate: new Date(),
            currentDateObra: new Date(),
            ptBR: ptBR,
            adicionandoMetragem: false,
            adicionandoCaracteristica: false,
            adicionandoFacilidade: false,
            adicionandoFicha: false,
            adicionandoQuarto: false,
            editandoFotos: false,
            seraOportunidade: false,
            entradaQuarto: {
                qtde: 0
            },
            entradaMetros: {
                metros: "",
                preco: "",
                index: ""
            },
            entradaCaracteristica: {
                icone: "",
                texto: ""
            },
            entradaFicha: {
                titulo: "",
                valor: ""
            },
            fotoEntrada: {
                path: "",
                banner: false,
                banner_mobile: false,
                texto: "",
                index: 0,
                md5: ""
            },
            entradaPlanta: {
                path: "",
                texto: "",
                md5: "",
                index: 0
            },
            empreendimento: {
                _id: "",
                titulo: "",
                slug: "",
                mes_lancamento: new Date().getMonth() + 1,
                ano_lancamento: new Date().getFullYear(),
                categoria: "",
                vendido: 0,
                construido: 0,
                metragem: [],
                localizacao: {
                    latitude: "",
                    longitude: "",
                    zona: "",
                    bairro: "",
                    endereco: "",
                    endereco_empreendimento: ""
                },
                badges: [],
                caracteristicas: [],
                facilidades: [],
                ficha_tecnica: [
                    {
                        titulo: "Arquitetura",
                        valor: ""
                    },
                    {
                        titulo: "Paisagismo",
                        valor: ""
                    },
                    {
                        titulo: "Terreno",
                        valor: ""
                    },
                    {
                        titulo: "Tipologia",
                        valor: ""
                    },
                    {
                        titulo: "Torres",
                        valor: ""
                    }
                ],
                contato_corretor: "",
                crm_whatsapp: "",
                destaque_home: 0,
                fotos: [],
                video: "",
                plantas: [],
                thumbnail: {
                    path: ""
                },
                imagem_regiao: "",
                tour: "",
                oportunidade: false,
                telefone: "",
                videos: [],
                em_construcao: false,
                status_construcao: {
                    geral: 0,
                    fundacao: 0,
                    estrutura: 0,
                    alvenaria: 0,
                    hidraulica: 0,
                    eletrica: 0,
                    acabamento: 0,
                    pintura: 0
                },
                ativo: false,
                quantidade_estoque: 0
            },
            optionsFichaTecnica: [
                "Arquitetura",
                "Paisagismo",
                "Terreno",
                "Tipologia",
                "Torres"
            ],
            optionsCategoria: [
                {
                    label: "Futuro Lançamento",
                    key: "futuro-lancamento"
                },
                {
                    label: "Breve Lançamento",
                    key: "breve-lancamento"
                },
                {
                    label: "Em construção",
                    key: "em-construcao"
                },
                {
                    label: "Lançamento",
                    key: "lancamento"
                },
                {
                    label: "Pronto para Morar",
                    key: "pronto-para-morar"
                }
            ],
            optionsCaracteristicasTexto: [
                {
                    label: "Academia",
                    key: "Academia",
                    icon: "dumbbell"
                },
                {
                    label: "Brinquedoteca",
                    key: "Brinquedoteca",
                    icon: "robot"
                },
                {
                    label: "Cantinho do Bate-papo",
                    key: "Cantinho do Bate-papo",
                    icon: "comments"
                },
                {
                    label: "Churrasqueira",
                    key: "Churrasqueira",
                    icon: "bacon"
                },
                {
                    label: "Churrasqueira com forno para pizza",
                    key: "Churrasqueira com forno para pizza",
                    icon: "pizza-slice"
                },
                {
                    label: "Dog Space",
                    key: "Dog Space",
                    icon: "dog"
                },
                {
                    label: "Escola",
                    key: "Escola",
                    icon: "school"
                },
                {
                    label: "Espaço Gourmet",
                    key: "Espaço Gourmet",
                    icon: "utensils"
                },
                {
                    label: "Espaço Piquenique",
                    key: "Espaço Piquenique",
                    icon: "sun"
                },
                {
                    label: "Estádio",
                    key: "Estádio",
                    icon: "futbol"
                },
                {
                    label: "Faculdade",
                    key: "Faculdade",
                    icon: "graduation-cap"
                },
                {
                    label: "Fitness",
                    key: "Fitness",
                    icon: "dumbbell"
                },
                {
                    label: "Hospital",
                    key: "Hospital",
                    icon: "hospital"
                },
                {
                    label: "Lavanderia",
                    key: "Lavanderia",
                    icon: "tshirt"
                },
                {
                    label: "Metrô",
                    key: "Metrô",
                    icon: "subway"
                },
                {
                    label: "Office",
                    key: "Office",
                    icon: "briefcase"
                },
                {
                    label: "Parque",
                    key: "Parque",
                    icon: "tree"
                },
                {
                    label: "Piscina",
                    key: "Piscina",
                    icon: "swimming-pool"
                },
                {
                    label: "Playground",
                    key: "Playground",
                    icon: "child"
                },
                {
                    label: "Praça do Tabuleiro",
                    key: "Praça do Tabuleiro",
                    icon: "chess-board"
                },
                {
                    label: "Praças",
                    key: "Praças",
                    icon: "leaf"
                },
                {
                    label: "Restaurante",
                    key: "Restaurante",
                    icon: "utensils"
                },
                {
                    label: "Redário",
                    key: "Redário",
                    icon: "yin-yang"
                },
                {
                    label: "Salão de Festas",
                    key: "Salão de Festas",
                    icon: "glass-cheers"
                },
                {
                    label: "Salão de Jogos",
                    key: "Salão de Jogos",
                    icon: "gamepad"
                },
                {
                    label: "Shopping",
                    key: "Shopping",
                    icon: "shopping-bag"
                },
                {
                    label: "Supermercados",
                    key: "Supermercados",
                    icon: "shopping-cart"
                },
                {
                    label: "Terminal",
                    key: "Terminal",
                    icon: "bus"
                }
            ],
            optionsCaracteristicasIcones: [
                "ambulance",
                "american-sign-language-interpreting",
                "anchor",
                "archway",
                "assistive-listening-systems",
                "atom",
                "award",
                "baby",
                "bacon",
                "balance-scale",
                "band-aid",
                "baseball-ball",
                "beer",
                "bicycle",
                "binoculars",
                "blind",
                "bone",
                "bowling-ball",
                "broadcast-tower",
                "bullhorn",
                "briefcase",
                "bus",
                "campground",
                "candy-cane",
                "charging-station",
                "chess-board",
                "child",
                "church",
                "clinic-medical",
                "cocktail",
                "coffee",
                "comments",
                "compact-disc",
                "deaf",
                "desktop",
                "dog",
                "dollar-sign",
                "drum",
                "drumstick-bite",
                "dumbbell",
                "female",
                "fighter-jet",
                "film",
                "fire-extinguisher",
                "football-ball",
                "futbol",
                "gamepad",
                "glass-cheers",
                "graduation-cap",
                "guitar",
                "hamburger",
                "helicopter",
                "hiking",
                "horse",
                "hospital",
                "hotdog",
                "ice-cream",
                "key",
                "language",
                "leaf",
                "location-arrow",
                "luggage-cart",
                "mail-bulk",
                "male",
                "map-marked-alt",
                "mask",
                "medkit",
                "monument",
                "moon",
                "mug-hot",
                "music",
                "paint-brush",
                "people-carry",
                "piggy-bank",
                "pizza-slice",
                "plane",
                "recycle",
                "restroom",
                "road",
                "robot",
                "rocket",
                "route",
                "school",
                "seedling",
                "shield-alt",
                "ship",
                "shopping-bag",
                "shopping-cart",
                "shower",
                "skating",
                "skiing",
                "skiing-nordic",
                "snowboarding",
                "snowman",
                "socks",
                "spa",
                "street-view",
                "subway",
                "sun",
                "swimming-pool",
                "table-tennis",
                "theater-masks",
                "tools",
                "tree",
                "tshirt",
                "tv",
                "umbrella",
                "university",
                "utensils",
                "vr-cardboard",
                "walking",
                "wheelchair",
                "wifi",
                "wine-glass",
                "wrench",
                "yin-yang"
            ],
            meses: [
                {
                    label: "Janeiro",
                    value: 1
                },
                {
                    label: "Fevereiro",
                    value: 2
                },
                {
                    label: "Março",
                    value: 3
                },
                {
                    label: "Abril",
                    value: 4
                },
                {
                    label: "Maio",
                    value: 5
                },
                {
                    label: "Junho",
                    value: 6
                },
                {
                    label: "Julho",
                    value: 7
                },
                {
                    label: "Agosto",
                    value: 8
                },
                {
                    label: "Setembro",
                    value: 9
                },
                {
                    label: "Outubro",
                    value: 10
                },
                {
                    label: "Novembro",
                    value: 11
                },
                {
                    label: "Dezembro",
                    value: 12
                }
            ],
            adicionandoVideo: false,
            entradaVideo: {
                video: "",
                video_preview: ""
            },
            fakeKeyToForceUpdate: 0,
            estaConstrucao: false
        };
    },
    methods: {
        voltar: function() {
            this.$router.push({ path: "/empreendimentos/lista" });
        },
        selectedCategoria: function(e) {
            if (e && e.label && e.label.length > 0) {
                this.empreendimento.categoria = e.key;
            }
        },
        selectedCaracteristica: function(e) {
            if (e && e.label && e.label.length > 0) {
                this.entradaCaracteristica.icone = e.icon;
                this.entradaCaracteristica.texto = e.label;
            }
        },
        checaSlug: function() {
            const fakeThis = this;
            fetch(
                this.$API_URL +
                    "/empreendimentos/slug/" +
                    this.empreendimento.slug,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("token")
                    }
                }
            )
                .then(response => response.json())
                .then(json => {
                    if (json.data.length > 0) {
                        fakeThis.uniqueSlug = false;
                    } else {
                        fakeThis.uniqueSlug = true;
                    }
                });
        },
        slugify: function(e) {
            if (e.code == "Space") {
                this.$nextTick(
                    () =>
                        (this.empreendimento.slug = this.empreendimento.slug
                            .split(" ")
                            .join("-"))
                );
            }
        },
        changeVideo: function() {
            if (this.entradaVideo.video.split("?v=").length > 0)
                this.entradaVideo.video_preview =
                    "https://www.youtube.com/embed/" +
                    this.entradaVideo.video.split("?v=")[1];
        },
        successUpload(e) {
            let resposta = JSON.parse(e.target.response).data;
            this.fotoEntrada.path = resposta.path;
            this.fotoEntrada.md5 = resposta.md5;

            let existe = false;

            this.empreendimento.fotos.forEach(foto => {
                if (foto.md5 == resposta.md5) existe = true;
            });

            if (!existe) this.empreendimento.fotos.push(this.fotoEntrada);

            this.fotoEntrada = {
                path: "",
                banner: false,
                banner_mobile: false,
                texto: "",
                md5: ""
            };
        },
        successUploadPlanta(e) {
            let resposta = JSON.parse(e.target.response).data;
            this.entradaPlanta.path = resposta.path;
            this.entradaPlanta.md5 = resposta.md5;

            let existe = false;

            this.empreendimento.plantas.forEach(planta => {
                if (planta.md5 == resposta.md5) existe = true;
            });

            if (!existe) this.empreendimento.plantas.push(this.entradaPlanta);

            this.entradaPlanta = {
                path: "",
                texto: "",
                md5: ""
            };
        },
        successUploadThumb(e) {
            let resposta = JSON.parse(e.target.response).data;
            this.empreendimento.thumbnail.path = resposta.path;
        },
        successUploadRegiao(e) {
            let resposta = JSON.parse(e.target.response).data;
            this.empreendimento.imagem_regiao = resposta.path;
        },
        successUploadTour(e) {
            let resposta = JSON.parse(e.target.response).data;
            this.empreendimento.tours.push({
                tour: resposta.path
            });
        },
        mudarDestaque: function(e) {
            if (e.type == "change") {
                if (!this.seraDestaque) this.empreendimento.destaque_home = 0;
            }
        },
        mudarConstrucao: function(e) {
            if (e.type == "change") {
                if (!this.estaConstrucao) {
                    this.empreendimento.em_construcao = 0;
                }
            } else {
                this.empreendimento.em_construcao = true;
            }
        },
        mudarAtivo: function(e) {
            if (e.type == "change") {
                if (!this.estaAtivo) {
                    this.empreendimento.ativo = 0;
                }
            } else {
                this.empreendimento.ativo = true;
            }
        },
        mudarCategoriaDestaque: function(e) {
            if (e.type == "change") {
                if (!this.seraCategoriaDestaque)
                    this.empreendimento.categoria_destaque = 0;
            }
        },
        mudarOportunidade: function(e) {
            if (e.type == "change") {
                if (!this.seraOportunidade)
                    this.empreendimento.oportunidade = false;
            } else {
                this.empreendimento.oportunidade = true;
            }
        },
        setDate: function(e) {
            this.empreendimento.ano_lancamento = e.getFullYear();
            this.empreendimento.mes_lancamento = e.getMonth() + 1;
        },
        setDateObra: function(e) {
            this.empreendimento.ano_obra = e.getFullYear();
            this.empreendimento.mes_obra = e.getMonth() + 1;
        },
        formatoData: function(date) {
            return (
                date.toLocaleString("default", { month: "long" }) +
                "/" +
                date.getFullYear()
            );
        },
        toggleBadge: function(e) {
            if (e.type == "change") {
                if (e.target.checked) {
                    this.empreendimento.badges.push({
                        titulo: e.target.parentElement.innerText.split("\n")[1],
                        pos: this.empreendimento.badges.length
                    });
                } else {
                    let indexRemocao = this.empreendimento.badges.filter(x => {
                        return (
                            x.titulo ==
                            e.target.parentElement.innerText.split("\n")[1]
                        );
                    });
                    this.empreendimento.badges.splice(indexRemocao[0].pos, 1);
                }
            }
        },
        textAreaAdjust: function(o) {
            o.target.style.height =
                o.target.scrollHeight > o.target.clientHeight
                    ? o.target.scrollHeight + "px"
                    : "53.29px";
        },
        remover: function(sessao, index) {
            if (sessao == "metragem") {
                this.empreendimento.metragem.splice(index, 1);
            } else if (sessao == "caracteristicas") {
                this.empreendimento.caracteristicas.splice(index, 1);
            } else if (sessao == "facilidades") {
                this.empreendimento.facilidades.splice(index, 1);
            } else if (sessao == "ficha") {
                this.empreendimento.ficha_tecnica.splice(index, 1);
            } else if (sessao == "foto") {
                this.empreendimento.fotos.splice(index, 1);
            } else if (sessao == "planta") {
                this.empreendimento.plantas.splice(index, 1);
            } else if (sessao == "quarto") {
                this.empreendimento.quartos.splice(index, 1);
            } else if (sessao == "video") {
                this.empreendimento.videos.splice(index, 1);
                this.fakeKeyToForceUpdate++;
            } else if (sessao == "tour") {
                this.empreendimento.tours.splice(index, 1);
            }
        },
        confirmarAdicao: function(sessao) {
            if (sessao == "metragem") {
                if (this.entradaMetros.index !== "") {
                    this.empreendimento.metragem[
                        this.entradaMetros.index
                    ] = this.entradaMetros;
                } else {
                    this.empreendimento.metragem.push(this.entradaMetros);
                }
            } else if (sessao == "caracteristicas")
                this.empreendimento.caracteristicas.push(
                    this.entradaCaracteristica
                );
            else if (sessao == "facilidades")
                this.empreendimento.facilidades.push(
                    this.entradaCaracteristica
                );
            else if (sessao == "ficha") {
                if (this.entradaFicha.index == "")
                    this.empreendimento.ficha_tecnica.push(this.entradaFicha);
                else
                    this.empreendimento.ficha_tecnica[
                        this.entradaFicha.index
                    ] = this.entradaFicha;
            } else if (sessao == "foto") {
                if (this.fotoEntrada.banner) {
                    this.empreendimento.fotos.forEach(foto => {
                        if (foto.banner) foto.banner = false;
                    });
                }
                if (this.fotoEntrada.banner_mobile) {
                    this.empreendimento.fotos.forEach(foto => {
                        if (foto.banner_mobile) foto.banner_mobile = false;
                    });
                }
                this.empreendimento.fotos[
                    this.fotoEntrada.index
                ] = this.fotoEntrada;
            } else if (sessao == "planta") {
                this.empreendimento.plantas[
                    this.entradaPlanta.index
                ] = this.entradaPlanta;
            } else if (sessao == "quarto") {
                this.empreendimento.quartos.push(this.entradaQuarto);
            } else if (sessao == "video") {
                this.empreendimento.videos.push(this.entradaVideo);
                this.fakeKeyToForceUpdate++;
            } else if (sessao == "tour") {
                this.empreendimento.tours[
                    this.entradaTour.index
                ] = this.entradaTour;
            }

            this.pararAdicao();
        },
        adicionar: function(sessao) {
            this.pararAdicao(sessao);
            if (sessao == "metragem") {
                this.adicionandoMetragem = true;
                this.$nextTick(() =>
                    document.getElementById("adicionarMetragemInput").focus()
                );
            } else if (sessao == "caracteristicas") {
                this.adicionandoCaracteristica = true;
            } else if (sessao == "facilidades") {
                this.adicionandoFacilidade = true;
            } else if (sessao == "ficha") {
                this.entradaFicha.index = "";
                this.adicionandoFicha = true;
                this.$nextTick(() =>
                    document.getElementById("adicionandoFichaInput").focus()
                );
            } else if (sessao == "quarto") {
                this.adicionandoQuarto = true;
                this.$nextTick(() =>
                    document.getElementById("adicionarQuartoInput").focus()
                );
            } else if (sessao == "video") {
                this.adicionandoVideo = true;
                this.$nextTick(() =>
                    document.getElementById("adicionandoVideoInput").focus()
                );
            }
        },
        editar: function(sessao, index) {
            this.pararAdicao(sessao);

            if (sessao == "foto") {
                this.fotoEntrada.texto = this.empreendimento.fotos[index].texto;
                this.fotoEntrada.banner = this.empreendimento.fotos[
                    index
                ].banner;
                this.fotoEntrada.banner_mobile = this.empreendimento.fotos[
                    index
                ].banner_mobile;
                this.fotoEntrada.path = this.empreendimento.fotos[index].path;
                this.fotoEntrada.md5 = this.empreendimento.fotos[index].md5;
                this.fotoEntrada.index = index;
                this.editandoFotos = true;
                this.$nextTick(() =>
                    document.getElementById("fotoEntradaTextoInput").focus()
                );
            } else if (sessao == "planta") {
                this.entradaPlanta.texto = this.empreendimento.plantas[
                    index
                ].texto;
                this.entradaPlanta.path = this.empreendimento.plantas[
                    index
                ].path;
                this.entradaPlanta.md5 = this.empreendimento.plantas[index].md5;
                this.entradaPlanta.index = index;
                this.editandoPlanta = true;
                this.$nextTick(() =>
                    document.getElementById("plantaEntradaTextoInput").focus()
                );
            } else if (sessao == "ficha") {
                this.entradaFicha.titulo = this.empreendimento.ficha_tecnica[
                    index
                ].titulo;
                this.entradaFicha.valor = this.empreendimento.ficha_tecnica[
                    index
                ].valor;
                this.entradaFicha.index = index;
                this.adicionandoFicha = true;
                this.$nextTick(() =>
                    document.getElementById("adicionandoFichaInput").focus()
                );
            } else if (sessao == "tour") {
                this.entradaTour.titulo = this.empreendimento.tours[
                    index
                ].titulo;
                this.entradaTour.tour = this.empreendimento.tours[index].tour;
                this.entradaTour.index = index;
                this.editandoTour = true;
                this.$nextTick(() =>
                    document.getElementById("tourEntradaTextoInput").focus()
                );
            } else if (sessao == "metragem") {
                this.entradaMetros.preco = this.empreendimento.metragem[
                    index
                ].preco;
                this.entradaMetros.metros = this.empreendimento.metragem[
                    index
                ].metros;
                this.entradaMetros.index = index;
                this.adicionandoMetragem = true;
            }
        },
        pararAdicao: function(sessao = "") {
            if (this.adicionandoMetragem && sessao != "metragem") {
                this.adicionandoMetragem = false;

                this.entradaMetros = {
                    metros: 0,
                    preco: 0,
                    index: ""
                };
            } else if (
                this.adicionandoCaracteristica &&
                sessao != "caracteristicas"
            ) {
                this.adicionandoCaracteristica = false;

                this.entradaCaracteristica = {
                    icone: "",
                    texto: ""
                };
            } else if (this.adicionandoFacilidade && sessao != "facilidades") {
                this.adicionandoFacilidade = false;

                this.entradaCaracteristica = {
                    icone: "",
                    texto: ""
                };
            } else if (this.adicionandoFicha && sessao != "ficha") {
                this.adicionandoFicha = false;

                this.entradaFicha = {
                    titulo: "",
                    valor: ""
                };
            } else if (this.editandoFotos && sessao != "foto") {
                this.editandoFotos = false;

                this.fotoEntrada = {
                    path: "",
                    banner: false,
                    banner_mobile: false,
                    texto: "",
                    md5: ""
                };
            } else if (this.editandoPlanta && sessao != "planta") {
                this.editandoPlanta = false;

                this.entradaPlanta = {
                    path: "",
                    banner: false,
                    texto: "",
                    md5: ""
                };
            } else if (this.adicionandoQuarto && sessao != "quarto") {
                this.adicionandoQuarto = false;

                this.entradaQuarto = {
                    qtde: 0
                };
            } else if (this.adicionandoVideo && sessao != "video") {
                this.adicionandoVideo = false;

                this.entradaVideo = {
                    videos: "",
                    video_preview: ""
                };
            } else if (this.editandoTour && sessao != "tour") {
                this.editandoTour = false;

                this.entradaTour = {
                    titulo: "",
                    tour: "",
                    index: 0
                };
            }
        },
        salvar: function() {
            if (!this.seraDestaque) this.empreendimento.destaque_home = 0;

            if (this.empreendimento.oportunidade)
                this.empreendimento.oportunidade = "true";
            else this.empreendimento.oportunidade = "false";

            let url = this.$API_URL + "/empreendimentos/";
            if (this.$route.params && this.$route.params.slug) {
                url += this.empreendimento._id;
            }

            fetch(url, {
                method: "POST",
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token")
                }),
                body: JSON.stringify(this.empreendimento)
            })
                .then(response => response.json())
                .then(json => {
                    if (json.status == "success") {
                        this.$vs.notify({
                            title: "Sucesso!",
                            text: "Salvo com sucesso.",
                            color: "primary"
                        });
                    } else {
                        this.$vs.notify({
                            title: "Erro!",
                            text: "Ocorreu um erro ao salvar.",
                            color: "danger"
                        });
                    }
                });
        },
        openTour: function(tour) {
            if (!(tour.indexOf("//") >= 0)) {
                tour = (this.$API_URL + tour).replace("/api", "");
            }
            window.open(tour, "_blank");
        },
        getDados: function() {
            if (this.$route.params && this.$route.params.slug) {
                fetch(
                    this.$API_URL +
                        "/empreendimentos/slug/" +
                        this.$route.params.slug,
                    {
                        method: "GET",
                        headers: new Headers({
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization:
                                "Bearer " + localStorage.getItem("token")
                        })
                    }
                )
                    .then(response => response.json())
                    .then(json => {
                        if (json.data[0].tours.length === 0) {
                            if (json.data[0].tour) {
                                json.data[0].tours.push({
                                    tour: json.data[0].tour
                                });
                            }
                        }

                        this.empreendimento = json.data[0];

                        if (!json.data[0].imagem_regiao) {
                            this.empreendimento.imagem_regiao = "";
                        }

                        if (json.data[0].destaque_home > 0)
                            this.seraDestaque = true;

                        if (json.data[0].categoria_destaque > 0)
                            this.seraCategoriaDestaque = true;

                        if (
                            !json.data[0].status_construcao ||
                            !json.data[0].status_construcao.geral
                        ) {
                            this.empreendimento.status_construcao = {
                                geral: 0,
                                fundacao: 0,
                                estrutura: 0,
                                alvenaria: 0,
                                hidraulica: 0,
                                eletrica: 0,
                                acabamento: 0,
                                pintura: 0
                            };
                        }

                        if (json.data[0].em_construcao)
                            this.estaConstrucao = true;

                        if (json.data[0].ativo) this.estaAtivo = true;

                        if (
                            json.data[0].mes_lancamento &&
                            json.data[0].ano_lancamento
                        )
                            this.currentDate = new Date(
                                json.data[0].ano_lancamento,
                                json.data[0].mes_lancamento - 1,
                                1
                            );

                        this.empreendimento.badges.forEach(badge => {
                            if (badge.titulo == "Use o seu FGTS")
                                this.badgeFGTS = true;
                            if (badge.titulo == "Minha Casa Minha Vida")
                                this.badgeMCMV = true;
                            if (badge.titulo == "Amplamente Financiado")
                                this.badgeAmplamente = true;
                            if (badge.titulo == "360 meses financiado")
                                this.badge360 = true;
                            if (badge.titulo == "Escritura Grátis")
                                this.escrituraGratis = true;
                            if (badge.titulo == "Black Friday 2020")
                                this.badgeBF = true;
                        });

                        if (this.empreendimento.oportunidade)
                            this.seraOportunidade = true;

                        if (this.empreendimento.destaque_home > 0)
                            this.seraDestaque = true;

                        if (
                            !this.empreendimento.videos ||
                            this.empreendimento.videos.length === 0
                        )
                            this.empreendimento.videos = [];

                        if (
                            this.empreendimento.videos.length === 0 &&
                            this.empreendimento.video
                        ) {
                            this.empreendimento.videos[0] = {
                                video: this.empreendimento.video,
                                video_preview:
                                    "https://www.youtube.com/embed/" +
                                    this.empreendimento.video.split("v=")[1]
                            };
                        }
                    });
            }
        }
    },
    mounted() {
        this.getDados();
    }
};
</script>

<style>
.fit-height {
    height: fit-content !important;
}

.img-upload {
    display: none !important;
}

.vs-divider {
    margin-top: 65px !important;
    font-weight: bold !important;
}

#formulario > div:nth-child(1) {
    margin-top: unset !important;
}

.vs-button-success.vs-button-flat {
    margin-top: 30px !important;
}

.con-vs-avatar {
    height: 108px !important;
    width: 108px !important;
}
</style>
